import { PlanogramItem, UnrangedPlanogramItem } from "@CommonTypes/merchflow/pog/item";
import { ResolvedOverlay, ResolverContext } from "./types";

export function resolveItemVisuals(
  item: PlanogramItem | UnrangedPlanogramItem,
  context: ResolverContext,
): ResolvedOverlay[] {
  const resolved: ResolvedOverlay[] = [];

  const { renderMode, labelText, isFixedSize } = context;

  if (renderMode === "label-only" || renderMode === "label-on-image") {
    const isOnImage = renderMode === "label-on-image";

    resolved.push({
      id: "base-text-label",
      anchor: isOnImage ? "bottom-center" : "center",
      content: labelText,
      style: {
        fontSize: isOnImage ? "9px" : "11px",
        textAlign: "center",
        fontWeight: isOnImage ? "bold" : "normal",
        color: "#000000",
        backgroundColor: isOnImage ? "rgba(255, 255, 255, 0.85)" : "transparent",
        padding: isOnImage ? "1px 2px" : "0",
        borderRadius: isOnImage ? "2px" : "0",
        ...(isFixedSize && {
          width: "14px",
          height: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }),
      },
      showOnImage: isOnImage,
      showOnLabelPlaceholder: !isOnImage,
    });
  }

  return resolved;
}
